import { ReactNode, useCallback, useState } from "react";
import { usePumpSizing } from "../../../context/PumpSizingContext";

type SavedResultIdBadgeProps = {
	className?: string;
	/** Rendered beside the ID row, matched to its height. */
	action?: ReactNode;
};

export function SavedResultIdBadge({
	className = "",
	action,
}: SavedResultIdBadgeProps) {
	const { savedSubmissionUuid } = usePumpSizing();
	const [copied, setCopied] = useState(false);

	const handleCopy = useCallback(async () => {
		if (!savedSubmissionUuid) {
			return;
		}

		try {
			await navigator.clipboard.writeText(savedSubmissionUuid);
			setCopied(true);
			window.setTimeout(() => setCopied(false), 2000);
		} catch {
			setCopied(false);
		}
	}, [savedSubmissionUuid]);

	if (!savedSubmissionUuid) {
		return null;
	}

	return (
		<div className={`pf-saved-result-id ${className}`.trim()}>
			<span className="pf-saved-result-id__label">Saved Result ID</span>
			<div className="pf-saved-result-id__line">
				<div className="pf-saved-result-id__row">
					<code className="pf-saved-result-id__value">
						{savedSubmissionUuid}
					</code>
					<button
						type="button"
						className="pf-saved-result-id__copy"
						onClick={handleCopy}
						aria-label={copied ? "Copied" : "Copy result ID"}
					>
						{copied ? "Copied" : "Copy"}
					</button>
				</div>
				{action}
			</div>
		</div>
	);
}
